<template>
  <Swiper
    v-bind="options"
    class="swiper-card-dates !-mx-4 box-content w-full !p-4"
    @swiper="emit('on-swiper', $event)"
  >
    <SwiperSlide v-for="item in data" :key="item.id ?? item.slug">
      <NuxtLink
        :to="{
          name: 'teacher-historical-calendar-slug',
          params: {
            slug: item.slug,
          },
        }"
      >
        <CardsDateCard :data="item" :class="{ 'bg-white-100': main }" />
      </NuxtLink>
    </SwiperSlide>
  </Swiper>
</template>

<script setup>
defineProps({
  data: {
    type: Array,
    default: () => [],
  },

  options: {
    type: Object,
    default: () => ({
      spaceBetween: 16,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
        1536: {
          slidesPerView: 5,
        },
      },
    }),
  },

  main: {
    type: Boolean,
    default: false,
  },
});

import { Swiper, SwiperSlide } from 'swiper/vue';

const emit = defineEmits(['on-swiper']);
</script>

<style lang="scss" scoped>
.swiper-slide {
  @apply h-auto;
}
.swiper-slide > a {
  @apply h-full;
}
</style>
